/**
 * CE Prefetch — beschleunigt Navigation gefuehlt.
 * Hover (Desktop) / Touchstart (Mobile) auf internen Links triggert
 * <link rel="prefetch">. Browser laedt die naechste Seite vor,
 * Navigation fuehlt sich instant an.
 */
(function () {
  if (!('connection' in navigator) ||
      navigator.connection.saveData ||
      /2g/.test(navigator.connection.effectiveType || '')) {
    return;
  }

  var prefetched = new Set();
  var hoverTimer = null;
  var HOVER_DELAY = 65;

  function isEligible(link) {
    if (!link || !link.href) return false;
    if (link.origin !== location.origin) return false;
    if (link.hash && link.pathname === location.pathname) return false;
    if (link.target === '_blank') return false;
    if (link.hasAttribute('download')) return false;
    if (link.dataset.noPrefetch !== undefined) return false;
    var href = link.href.split('#')[0];
    if (prefetched.has(href)) return false;
    // Skip cart/account/admin actions
    if (/\/cart\/|\/account\/|\?.*_=/.test(href)) return false;
    return true;
  }

  function prefetch(href) {
    if (prefetched.has(href)) return;
    prefetched.add(href);
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    l.as = 'document';
    document.head.appendChild(l);
  }

  function handleEnter(e) {
    var link = e.target.closest && e.target.closest('a');
    if (!isEligible(link)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () {
      prefetch(link.href.split('#')[0]);
    }, HOVER_DELAY);
  }

  function handleLeave() {
    clearTimeout(hoverTimer);
  }

  function handleTouch(e) {
    var link = e.target.closest && e.target.closest('a');
    if (!isEligible(link)) return;
    prefetch(link.href.split('#')[0]);
  }

  document.addEventListener('mouseover', handleEnter, { passive: true });
  document.addEventListener('mouseout', handleLeave, { passive: true });
  document.addEventListener('touchstart', handleTouch, { passive: true });
})();
